// Static hero / section imagery (AI-generated luxury fashion photography)
const BASE = "https://static.prod-images.emergentagent.com/jobs/7afd75fb-81f3-4136-b5f3-f1c49155676f/images";

export const MEDIA = {
  hero: `${BASE}/e65a51521b10534ee019e823d6bd5231ecc76ab4d37c6d3b196e1baab90e2a95.png`,
  catSarees: `${BASE}/d7929a51a508ed357399da4d01c1b8a49b4ff40960f8b658e50e00fbdc433220.png`,
  catLehengas: `${BASE}/94bc360f4cabd09be92de29835262874118ade13a2638950746e43b717f433bd.png`,
  catSuits: `${BASE}/d07a61048603814f7c829c54f2b2b1018d6c05d0d8777bcfc356a744087c8384.png`,
  catJewellery: `${BASE}/937ea3e84cd18f95b141212c67773f07b1ab3b9862e1151e6a2a073a750fe921.png`,
  catNewIn: `${BASE}/705a725989013283883cb7e7380f27678cd35c47cb040cc43fab795e0a84f7ed.png`,
  about: `${BASE}/fe6582e07e2641204f8d0ab28e03da6f16bef71566c18bdc7cee69d767d59a87.png`,
  saleFabric: `${BASE}/e6d3a48023ad72fae41cd1b1f2f0e74909060303a84ea0eddf06bcb1c7e2a9d8.png`,
};

export const CATEGORIES = [
  { slug: "bridal-sets", name: "Bridal Sets", tagline: "The Statement", image: MEDIA.catLehengas },
  { slug: "necklace-sets", name: "Necklace Sets", tagline: "Kundan · Polki · Temple", image: MEDIA.catJewellery },
  { slug: "bangles", name: "Bangles", tagline: "Kadas & Chudis", image: MEDIA.catSuits },
  { slug: "earrings", name: "Earrings", tagline: "Jhumkas & Chandbalis", image: MEDIA.catSarees },
];
